module.exports = __webpack_public_path__ + "static/media/7.ef5d6898.JPG";